import React from 'react';
import ReactDOM from 'react-dom';
import {
	Drawer, Collapse, List, Badge, Form, Empty, Checkbox, Button, message, Col, Row,
	Input, Select, DatePicker, Space, Card, AutoComplete, Mentions, Divider, Radio, Spin,
	Tabs, Dropdown, Menu, notification
} from 'antd';
import { PushpinOutlined, CalendarOutlined, PlusOutlined, CloseOutlined, DownCircleOutlined } from '@ant-design/icons';
import { APIService } from '../../../services/projectManager/api';
import { __waterDocumentSvg } from '../../../lib/waterMarking.js';
import BaseInfo from './Pages/BaseInfo.jsx';
import FAInfo from './Pages/FAInfo.jsx';
import TAInfo from './Pages/TAInfo.jsx';
import ShowRecord from '../showRecord/ShowRecord.jsx';
import {PMAPI,PMENUM} from '../../../lib/postmsg';
import reactDialog from '../../../lib/editableDialog';
import approveCommonet from '../showRecord/approve-commonet.js';
import './ProjectManager.scss';
import 'antd/dist/antd.css';
import moment from 'moment';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';

const tabList = [
	{
		key: 'base',
		tab: '产品基础信息',
	},{
		key: "FA",
		tab: "投资交易及FA估值规则",
	},{
		key: "TA",
		tab: "申赎交易及TA清算规则",
	}
]

const tabContent = (key, rowId, data, info , formRef) => {
	return {
		'base': <BaseInfo key={`${key}_${rowId}`} data={data} ref="base" formRef={formRef}/>,
		'FA': <FAInfo key={`${key}_${rowId}`} data={data} ref="FA" formRef={formRef}/>,
		'TA': <TAInfo key={`${key}_${rowId}`} data={data} ref="TA" info={info} formRef={formRef}/>,

	}[key]
}

class ProjectManager extends React.Component{

	constructor(props) {
		super(props);
	
		this.state = {
			key: 'base',
			isEdit: this.props.data.isEdit,
			rowId: this.props.data.rowId,
			formData: {},
			cache_old: {},
			commont: '',
			record_info: {},
			action: 0,
			loading: false,
			submitLoading: false,
		};

		this.domRef = null;
		
		this.setCallBackRef = element => {
            this.domRef = element
        }

        this.formRef = React.createRef();
	}

	componentDidMount() {
		if(!this.props.data.isAdd){
			this.getFormData();
		}
	}

	componentWillUnmount(){
	    this.setState = (state,callback) =>{
	      return;
	    };
	}

	onTabChange = (key) => {
		const { formData } = this.state;
		this.setState((prev, props) => {
			return { key: key }
		})
	};

	submit = () => {
		// const { key, rowId } = this.state;
		// if(key!='base' && !rowId){
		// 	message.warning('您当前未填写产品重要信息,请检查基础信息是否完整!');
		// 	return ;
		// }
		// this.refs[key].formRef.current.submit();
		this.formRef.current.submit();
	};
	
	onFinish = (formsValue) => {
		const { type } = this.props.data;
		this.setState((prev, props) => {
			return { loading: true, submitLoading: true}
		})
		const date_fields = ['f11', 'f12', 'f107', 'f102'];
		let values = {};
		Object.keys(formsValue).map(field => {
			if(formsValue[field] != undefined){
				if(date_fields.includes(field)){
					values[field] = formsValue[field].format('YYYY-MM-DD')
				}else{
					values[field] = formsValue[field]
				}
			}
		})
		console.log('formdata', values)
		if(type == 'approve'){
			const { record_id, flow_id } = this.props.data;
			const { cache_old, commont, action } = this.state;
 			let param = {
				record_id: record_id,
				flow_id: flow_id,
				flow_name: '项目管理流程',
				action: action,
				comment: commont,
				data: JSON.stringify(values),
				cache_old: JSON.stringify(cache_old),
				cache_new: JSON.stringify(values),
			}
			APIService.ApproveWorkflow(param).then(res => {
				if(res.success){
					message.success('审批成功');
					this.props.data.event.closeDialog();
				}else{
					message.error(res.error);
					this.setState((prev, props) => {
						return {loading: false, submitLoading: false}
					})
				}
			}).catch(err => {
				console.log('审批项目管理流程 Error', err);
				this.setState((prev, props) => {
					return {loading: false, submitLoading: false}
				})
			})
		}else{
			let param = {
				flow_name: '项目管理流程',
				form_data: JSON.stringify(values),
				record_info: JSON.stringify(this.state.record_info)
			}
			APIService.FastCreateWorkflow(param).then(res => {
				if(res.success){
					message.success('项目管理流程提交成功');
					this.props.data.event.closeDialog();
				}else{
					message.error(`项目管理流程提交失败, Error:${res.error}`)
				}
				this.setState((prev, props) => {
					return { loading: false, submitLoading: false }
				})
			}).catch(err => {
				console.log('创建项目管理流程的信息Error', err)
				if(err.status == 500){
					message.error('服务器错误,信息提交失败!')
				}
				this.setState((prev, props) => {
					return { loading: false, submitLoading: false }
				})
			})
		}
	};

	setRowId = (id) => {
		let { formData } = this.state;
		this.setState((prev, props) => {
			return { rowId: id, formData: {...prev.formData, _id: id } }
		})
	};

	getFormData = () => {
		const { record_id, rowId } = this.props.data;
		const { key } = this.state;
		this.setState((prev, props) => {
			return { loading: true}
		})
		let param = {
			record_id: record_id,
			row_id: rowId
		}
		APIService.GetProjectDetail(param).then(res => {
			if(res.success){
				console.log("项目查看",res)
				let formData = {}, cache_old = {}
				const date_list = ['f11', 'f12', 'f107', 'f102'];
				Object.keys(res.row).map(field => {
					if(res.row[field]){
						if(date_list.includes(field)){
							formData[field] = moment(res.row[field], 'YYYY-MM-DD');
						}else{
							formData[field] = res.row[field];
							cache_old[field] = res.row[field];
						}
					}
				})
				this.setState((prev, props) => {
					return { formData: formData, loading: false, rowId: formData['_id'], cache_old: cache_old, record_info: res.record_info }
				}, () => this.formRef.current.setFieldsValue(formData))
			}else{
				message.error(res.error);
				this.setState((prev, props) => {
					return {loading: false}
				})
			}
		}).catch(err => {
			console.log('获取项目管理详细信息Error', err);
			this.setState((prev, props) => {
				return {loading: false}
			})
		})
	};

	/**
	 * [审批方法]
	 * @return {[type]} [description]
	 */
	approve = () => {
		let t = window.devicePixelRatio
		var that = this;
		PMAPI.openDialogToSelfByComponent(approveCommonet, {
            // width: window.innerWidth,
            // height: window.innerHeight,
			width: 800,
			height:  500,
			title: '审批流程',
	        iszoom:true,
			special:true,
		}).then((data) => {
			console.log('approve', data)
			if(!data.onlyclose && data.type == 'submit'){
				that.setState((prev, props) => {
					return { action: 0, commont: data.commont}
				}, () => that.formRef.current.submit())
			}
		})
	};

	reject = (opa) => {
		var that = this;
		var action = opa;
		var title = opa == 2? '驳回到发起人': '驳回到上一节点';
		PMAPI.openDialogToSelfByComponent(approveCommonet, {
            // width: window.innerWidth,
            // height: window.innerHeight,
			width: 800,
			height: 500,
            title: `流程 ${title}`,
			iszoom:true,
			special:true,
		}).then((data) => {
			console.log('approve', data)
			if(!data.onlyclose && data.type == 'submit'){
				that.setState((prev, props) => {
					return { action: action, commont: data.commont}
				}, () => that.formRef.current.submit())
			}
		})
		// this.setState((prev, props) => {
		// 	return { action: opa, commont: ''}
		// }, () => this.formRef.current.submit())
	};

	alertMessage = (values) => {
		console.log('form error values', values['errorFields'])
		let Mess = () => (
			<div>
			{values['errorFields'].map(err => (
				<p key={err.errors}>{err.errors}</p>
			))}
			</div>
		);
		notification['error']({
			message: '表单验证失败',
			description: <Mess />,
			placement: 'bottomRight'
		})
	};

	render(){
		const { isEdit, formData, loading, rowId, submitLoading, formError , record_info} = this.state;
		const { showRecord, record_id, type, isFrom, viewMode , record } = this.props.data;
		return(
			<div className="ProjectManager">
				<Card
					style={{width: '100%'}}
					title={
						<Row gutter={[8, 8]}>
							<Col span={24}>
								<div className='ProjectManager-title'>
									标准化产品投资信托业务运营要素表
								</div>
							</Col>
						</Row>
					}
					extra={
						type=='approve'?
						<Space>
							<Button
								type="primary"
								onClick={this.approve}
								loading={submitLoading}
							>
								审批
							</Button>
							<Dropdown
								overlay={
									<Menu>
										<Menu.Item key="1" onClick={() => this.reject(2)}>
											驳回到发起人
										</Menu.Item>
										<Menu.Item key="2" onClick={() => this.reject(1)}>
											驳回上一节点
										</Menu.Item>
									</Menu>
								}
								getPopupContainer={triggerNode => triggerNode.parentElement}
								arrow={true}
								trigger={['click']}
							>
								<Button
									danger
									type="primary"
									loading={submitLoading}
								>
									驳回
									<DownCircleOutlined />
								</Button>
							</Dropdown>
						</Space>:
						isFrom=='workflow'?"":
						viewMode=='in_process'?"":
						isEdit?<Button 
							type="primary" onClick={this.submit}
							loading={submitLoading}
						>提交</Button>:
						<Button 
							type="primary" 
							onClick={()=> {
								if(record.status == 2 ){
									message.warning('该项目流程还在审批中,不可编辑');
									return
								}else {
									this.setState((prev, props) => {return { isEdit: true }})
								}
							}}
						>
							转到编辑
						</Button>
					}
				>
				<Spin
					size="large"
					spinning={loading}
				>
				<Form
					ref={this.formRef}
					name='base'
					labelAlign="left"
					layout="inline"
					initialValues={formData}
					onFinish={this.onFinish}
					autoComplete="off" // 关闭输入框自动提示输入历史
					onFinishFailed={this.alertMessage}
				>

					<Tabs 
						activeKey={this.state.key}
						onChange={this.onTabChange}
						style={{width: '100%'}}
					>
						{
							tabList.map(tab => (
								<Tabs.TabPane 
									key={tab.key} tab={tab.tab}
								>
									{tabContent(tab.key, Object.keys(formData).length, { isEdit: isEdit, setRowId: this.setRowId, formData: formData }, record_info.f144 , this.formRef)}
								</Tabs.TabPane>

							))
						}
					</Tabs>
				</Form>
				</Spin>
				</Card>
				{
					showRecord &&
					<ShowRecord record_id={record_id}/>
				}
				
			</div>
		)
	}
}

export default ProjectManager;


// WEBPACK FOOTER //
// app/components/customPage/project-manager/ProjectManager.jsx